import { Component, inject } from '@angular/core'

import { MessageService } from 'primeng/api'
import { Button } from 'primeng/button'
import { DynamicDialogRef } from 'primeng/dynamicdialog'

import { UpdateService } from '@app/services/update.service'
import { UserService } from '@app/services/user.service'

@Component({
  template: `
    <div class="field-label" i18n="@@update-message">Acted Archives v2 has been updated! Please click on the update button below to update and reload the app.</div>
    <div style="margin: 30px 0 10px 0; text-align: right">
      <div class="field-label">
        <p-button icon="fa fa-solid fa-xmark" i18n-label="@@common-close" label="Close" (onClick)="onClose()" severity="secondary"></p-button>
        <p-button icon="fa fa-solid fa-rotate-right" i18n-label="@@update-do-update" label="Update" (onClick)="update()" class="ml-1"></p-button>
      </div>
    </div>
  `,
  imports: [Button],
})
export class UpdateComponent {
  private readonly updateService = inject(UpdateService)
  public readonly messageService = inject(MessageService)
  public readonly userService = inject(UserService)
  public readonly ref = inject(DynamicDialogRef)

  onClose () {
    this.ref.close()
  }

  update () {
    this.updateService.update()
  }
}
